import type { TranslateFn } from '@/composables/TranslateFn'
import type { AppProblemModel } from '@/services/api/AppProblemModel'
import { problemReasonMessage } from './problemReasonMessage'
import { fieldIssuesMessage } from '@/composables/fieldIssuesMessage'
import { retrySuffix } from './retrySuffix'
import { problemMessage } from './problemMessage'

/**
 * The canonical display message for a normalized problem: resolves
 * `problemReasonMessage()` first, falling back to `problemMessage()` (which
 * still trusts `problem.detail` for codes marked `trustServerDetail`) only
 * when the problem carries no `reason`. This is the call every presentation
 * sink should make instead of reading `problem.detail`/`problemMessage()`
 * directly, so a call site's display text upgrades automatically the moment
 * the backend starts sending a `reason` for that failure path -- no consumer
 * change required.
 */
export const resolveProblemMessage = (
  problem: AppProblemModel,
  t: TranslateFn,
  fallback?: string
): string => {
  const reasonMessage = problemReasonMessage(problem, t)
  if (reasonMessage !== null) return reasonMessage

  const issuesMessage = problem.code === 'VALIDATION_ERROR' ? fieldIssuesMessage(problem, t) : null
  if (issuesMessage !== null) return `${issuesMessage}${retrySuffix(problem, t)}`

  return problemMessage(problem, t, fallback)
}
